"use client";
import { Button } from "@/components/ui/button";
import { Navbar_Menu_List } from "@/lib/dto/header/menu";
import { system } from "@/lib/dto/system/system";
import { LogoDvekrestRounded } from "@/lib/images";
import Image from "next/image";
import Link from "next/link";
import { DropdownItem } from "./dropdown-item";

interface NavSheetProps {
  onClose: () => void;
}

export function NavSheet({ onClose }: NavSheetProps) {
  return (
    <div className="flex flex-col h-full max-h-full">
      {/* Header */}
      <div className="flex items-center justify-between p-6 border-b border-gray-200/50 shrink-0">
        <div className="flex items-center space-x-2">
          {/* Logo */}
          <Image
            src={LogoDvekrestRounded}
            alt={system.company_name}
            width={32}
            height={32}
            className="w-8 h-8 object-contain"
          />
          <span className="font-semibold text-gray-900">Devkrest</span>
        </div>
        {/* <Button
          variant="ghost"
          size="icon"
          onClick={onClose}
          className="hover:bg-gray-100 rounded-xl"
        >
          <X className="h-5 w-5 text-gray-600" />
          <span className="sr-only">Close menu</span>
        </Button> */}
      </div>

      {/* Navigation Items - Adding overflow handling */}
      <nav className="flex-1 p-6 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-transparent scrollbar-thumb-rounded-md">
        <ul className="space-y-2 pb-6">
          {Navbar_Menu_List.map((item) => (
            <li key={item.id}>
              {item.sublinks && item.sublinks.length > 0 ? (
                <DropdownItem
                  title={item.title}
                  icon={item.icon}
                  items={item.sublinks}
                  onItemClick={onClose}
                />
              ) : (
                <a
                  href={item.path || "#"}
                  onClick={onClose}
                  className="flex items-center space-x-3 px-4 py-3 rounded-2xl text-gray-700 hover:bg-gray-100/80 hover:text-gray-900 transition-all duration-200 group"
                >
                  {item.icon && (
                    <item.icon className="h-5 w-5 text-gray-500 group-hover:text-gray-700 transition-colors" />
                  )}
                  <span className="font-medium">{item.title}</span>
                </a>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-6 border-t border-gray-200/50 shrink-0">
        <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-4">
          <h3 className="font-semibold text-gray-900 mb-1">Get Started</h3>
          <p className="text-sm text-muted-foreground mb-3">
            Ready to take your project to the next level?
          </p>
          {/* <Button
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 rounded-xl shadow-lg"
            onClick={onClose}
          >
            Contact Us
          </Button> */}
          <Link href="/contact-us" onClick={onClose}>
            <Button className="shadow-none rounded-full cursor-pointer px-4 py-2 font-medium text-base">
              <p> Build Digital Solutions</p>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
